
import { defineComponent } from 'vue'
import PageNote from '@/components/page-index'
import CpnSynopsis from '@/components/cpn/cpn-synopsis.vue'
import CpnIntroduce from '@/components/cpn/cpn-introduce.vue'
import CpnRanking from '@/components/cpn/cpn-ranking.vue'

export default defineComponent({
  components: { PageNote, CpnSynopsis, CpnIntroduce, CpnRanking },
  setup() {
    return {}
  }
})
